import React, {ChangeEvent, ReactElement} from 'react';
import {useIntl} from 'react-intl';
import Field from '../Field/Field';
import {Field as FieldType, Option} from '../types';

interface Props extends Omit<FieldType, 'onChange' | 'onBlur'> {
  options: Option[];
  onChange: (event: ChangeEvent<HTMLSelectElement>) => void;
  onBlur?: (event: ChangeEvent<HTMLSelectElement>) => void;
}

function Select({
  assistiveMessage = '',
  errorMessage = '',
  label,
  name,
  onChange,
  onBlur = () => {
    /* noop */
  },
  options,
  placeholder,
  value,
  warningMessage = '',
  isDisabled,
  formikFieldName,
  testId,
}: Props): ReactElement {
  const {formatMessage} = useIntl();

  return (
    <Field
      name={name}
      label={label}
      errorMessage={errorMessage}
      warningMessage={warningMessage}
      assistiveMessage={assistiveMessage}
      isDisabled={isDisabled}
    >
      <select
        id={name}
        name={name}
        data-formik-field-name={formikFieldName}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
        className={value ? '' : 'select--noSelection'}
        disabled={isDisabled}
        data-testid={testId}
      >
        <option value="">{placeholder || formatMessage({id: 'phoenix.fields.select.defaultPlaceholder'})}</option>
        {options.map(({label: optionLabel, value: optionValue}) => (
          <option key={optionValue} value={optionValue}>
            {optionLabel}
          </option>
        ))}
      </select>
    </Field>
  );
}

export default Select;
